module.exports = __webpack_public_path__ + "assets/img/24_1073.8309a78d.jpg";